<template>
  <v-app>
    <div>
      <AdSmp />
      <div class="mt-4 mx-8">
        <v-layout
          align-center
          class="ma-0 pa-0"
          d-flex
          justify-start
          style="height: 60px;background-color: var(--v-background2-base)"
        >
          <div
            :style="`width:5px; height:100%;background-color:var(--v-secondary-base)`"
            class="mr-4"
          />
          <div style="font-weight: bold;font-size: 18px;">
            プレビュー
          </div>
        </v-layout>
      </div>
      <p
        :class="`pa-4 mt-4 mx-8 mb-1 grey-text normal-text-area-${fontSizeIndex*1.1}`"
        style="font-weight:bold;background-color: var(--v-background2-base)"
      >
        {{ page.name }}
      </p>
      <p
        :class="`pa-4 mt-4 mx-8 mb-6 grey-text normal-text-area-${fontSizeIndex}`"
        :style="`background-color: var(--v-background2-base); line-height:${lineSpaceSize}em`"
        v-html="preview"
      />
    </div>
  </v-app>
</template>

<script>
import {mapState} from "vuex";
import config from "@/const";
import firebase from "firebase/app";
import axios from "axios";
import AdSmp from '../component/AdSmp.vue';
import rubiConverter from "@/component/rubiConverter";
export default {
  name: "TextPreview",
  components: {
    AdSmp,
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
      fontSize: state => state.userModule.user.writerFontSizeTypeKeyValue.size * 13,
      fontSizeIndex: state => state.userModule.user.writerFontSizeTypeKeyValue.value,
      lineSpaceSize: state => state.userModule.user.writerLineSpaceTypeKeyValue.size
    }),
  },
  data() {
    return {
      page: {},
      preview: ""
    }
  },
  watch: {
    $route: {
      async handler() {
        const novel = this.$store.state.NovelListModule.NovelList.find(item => item.id == config.HASH_IDS.decode(this.$route.params.novelid)[0])
        if (novel == null) {
          this.$router.push({name: 'Novels'})
        } else {
          this.siteType = config.findSiteType(novel.targetSite);
          const user = firebase.auth().currentUser
          const token = await user.getIdToken(false)
          if (token == null) {
            return
          }
          // console.log("token="+token)
          const ret = await axios.get(config.API_URL + "auth/page", {
            headers: {"X-Firebase-Auth": token},
            params: {
              "id": config.HASH_IDS.decode(this.$route.params.text_id)[0]
            },
            data: {}
          })
          if (!ret.data) {
            this.$router.push({
              name: 'TextEdit',
              params: {novelid: config.HASH_IDS.decode(this.$route.params.novelid)[0], text_id: 'create'}
            })
          } else {
            this.page = ret.data
            if(this.siteType.value==7)
              this.preview =this.page.content.replaceAll("\n", "<br/>")
            else
            this.preview =rubiConverter.previewRubiConvert(this.escape_html(this.page.content))
          }
        }
      }, immediate: true
    },
  },
  methods: {
    escape_html(string) {
      if (typeof string !== 'string') {
        return string;
      }
      return string.replace(/[&'`"<>]/g, function (match) {
        return {
          '&': '&amp;',
          "'": '&#x27;',
          '`': '&#x60;',
          '"': '&quot;',
          '<': '&lt;',
          '>': '&gt;',
        }[match]
      });
    },
  }
}
</script>

<style scoped>

</style>